
/**
 * 方位角测量
 */

import DrawPolyline from "../plot/DrawPolyline"
import ConstantDraw from "../constants/ConstantDraw"
import { cartesian2lonlat } from "./utils/geojson.js"
import { formatDegree, formatNum } from "./utils/space"
class BearSpace extends DrawPolyline {

    constructor(options) {
        super(options);
        this.options = options;
        this.northPoleOffset = 5; //北纬十度
        this.style={
            clampToGround:false
        }
        this.entitiesLabel=[];
    }

    leftClick(evt) {
        if (!this.plot) {
            super.leftClick(evt);

            var lonlat = cartesian2lonlat(this.positions[0]);

            var northPole = Cesium.Cartesian3.fromDegrees(lonlat[0], lonlat[1] + this.northPoleOffset, 0);
            this.positions.unshift(northPole);

            var cartesian = this.positions[0];
            this.northPoint = this.createPoint(cartesian);
            var label = ConstantDraw.Style_Label;
            label.text = "正北方向";
            this.northPoint.label = label;

            var cartesian = this.positions[1];
            this.startPoint = this.createPoint(cartesian);

            var cartesian = this.positions[2];
            var label = ConstantDraw.Style_Label;
            label.text = "终点";
            this.endPoint = this.createPoint(cartesian);
            this.endPoint.label = label;

            this.entities.push(this.northPoint);
            this.entities.push(this.startPoint);
            this.entities.push(this.endPoint);
            this.entitiesLabel.push(this.northPoint);
            this.entitiesLabel.push(this.startPoint);
            this.entitiesLabel.push(this.endPoint);
        }
    }

    mouseMove(evt) {
        var $this = this;
        if ($this.positions.length < 1) return;
        var cartesian = $this.getCatesian3FromPX(evt.endPosition);
        if (!cartesian) {
            return;
        }
        if (!$this.Cesium.defined($this.plot)) {
            $this.plot = $this.createPolyline($this.positions, this.style);
            this.entities.push($this.plot);
        }
        if ($this.plot) {
            $this.positions.pop();
            $this.positions.push(cartesian);
            $this.endPoint.position.setValue(cartesian);
            $this.updateBear();
        }

    }
    reset() {
        super.reset();
        this.startPoint = null;
        this.endPoint = null;
        this.entitiesLabel=[];
    }

    updateBear() {
        var point1 = this.startPoint.position.getValue();
        var point2 = this.endPoint.position.getValue();
        var angle = this.getAzimuthAngle(point1, point2);
        var label = ConstantDraw.Style_Label;
        label.text = "方位角:" + formatDegree(angle) + "\n(度数):" + formatNum(angle, 6);
        this.startPoint.label = label;
    }

    /**
    * 计算两个点的方位角度
    * @return {number}
    */
    getAzimuthAngle(pointA, pointB) {

        //以a点为原点建立局部坐标系（东方向为x轴,北方向为y轴,垂直于地面为z轴），得到一个局部坐标到世界坐标转换的变换矩阵
        const localToWorld_Matrix = Cesium.Transforms.eastNorthUpToFixedFrame(pointA);
        //求世界坐标到局部坐标的变换矩阵
        const worldToLocal_Matrix = Cesium.Matrix4.inverse(
            localToWorld_Matrix,
            new Cesium.Matrix4()
        );
        //a点在局部坐标的位置，其实就是局部坐标原点
        const localPosition_A = Cesium.Matrix4.multiplyByPoint(
            worldToLocal_Matrix,
            pointA,
            new Cesium.Cartesian3()
        );
        //B点在以A点为原点的局部的坐标位置
        const localPosition_B = Cesium.Matrix4.multiplyByPoint(
            worldToLocal_Matrix,
            pointB,
            new Cesium.Cartesian3()
        );

        // 求出单位向量
        const vector = new Cesium.Cartesian3(
            localPosition_B.x - localPosition_A.x,
            localPosition_B.y - localPosition_A.y,
            localPosition_B.z - localPosition_A.z
        );
        const unitVector = Cesium.Cartesian3.normalize(vector, new Cesium.Cartesian3());

        // 通过向量的方式计算两个点的夹角，得到角度
        const angleRadians = Math.atan2(unitVector.x, unitVector.y);
        let theta = angleRadians * (180 / Math.PI);
        return theta;
    }
    initEditor() {
    }

}

export default BearSpace;